// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2-puD","log":"ModalInventoryLogs_log__15Uv9","date":"ModalInventoryLogs_date__ASGcx","userName":"ModalInventoryLogs_userName__vh-R0"};